var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.220312 1.27969C-0.0734375 0.985938 -0.0734375 0.510938 0.220312 0.220312C0.514062 -0.0703125 0.989063 -0.0734375 1.27969 0.220312L5.99844 4.93906L10.7172 0.220312C11.0109 -0.0734375 11.4859 -0.0734375 11.7766 0.220312C12.0672 0.514062 12.0703 0.989063 11.7766 1.27969L7.05781 5.99844L11.7766 10.7172C12.0703 11.0109 12.0703 11.4859 11.7766 11.7766C11.4828 12.0672 11.0078 12.0703 10.7172 11.7766L5.99844 7.05781L1.27969 11.7766C0.985938 12.0703 0.510938 12.0703 0.220312 11.7766C-0.0703125 11.4828 -0.0734375 11.0078 0.220312 10.7172L4.93906 5.99844L0.220312 1.27969Z",
    fill: "#01152E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseX);
export default __webpack_public_path__ + "static/media/close-x.3919cca417ceb6821d2186c27d57064c.svg";
export { ForwardRef as ReactComponent };